import pegasus from '../../assets/scripts/global/01-pegasus.js';
export default class Container {
    expanded = false;
    visible = false;
    animateIn = false;
    isIconsText = false;
    containerHeight = 0;
    dontContract = false;

    constructor(animateIn) {
        this.animateIn = animateIn;
    }

    init() {
        // log if any child of this element has the class 'Animated__Logo'
        const checkForLogo = (element) => {
            if(!element) {
                return;
            }
            if (element.classList && element.classList.contains('IconsText')) {
                console.log('Found IconsText');
                this.isIconsText = true;
            }

            for (let child of element.children) {
                checkForLogo(child);
            }
        };

        checkForLogo(this.$refs.container);

        if (!this.animateIn) {
            this.show();
        }

        this.contractOnMobile();
        this.expandOnMobile();
    }

    toggle() {
        this.expanded = !this.expanded;
    }

    show() {
        this.visible = true;
    }

    contractOnMobile() {
        const targetContainer = document.querySelector('.contract-on-mobile');
        if(!targetContainer) {
            return;
        }

        const childContainer = targetContainer.firstElementChild;

        pegasus.onResizeFinished(() => {
            targetContainer.style.height = '';
            targetContainer.style.overflow = '';
            this.containerHeight = targetContainer.offsetHeight;

            if(window.innerWidth > 768 || this.dontContract) {
                targetContainer.style.height = '';
                targetContainer.style.overflow = '';
                childContainer.classList.add('h-full');
                return;
            }
            targetContainer.style.height = (this.containerHeight/2) - 75 + 'px';
            childContainer.classList.remove('h-full');
            targetContainer.style.overflow = 'hidden';
        },true);
    }

    expandOnMobile() {
        const thisElement = document.querySelector('.expand-on-mobile');
        if(!thisElement) {
            return;
        }
        const parentElement = thisElement.closest('.Pegasus__Container');
        const previousSibling = parentElement.previousElementSibling;

        if(!parentElement || !previousSibling || !previousSibling.classList.contains('contract-on-mobile')) {
            return;
        }

        const button = thisElement.querySelector('a.wp-element-button');

        button.addEventListener('click', e => {
            e.preventDefault();
            previousSibling.style.height = '';
            parentElement.remove();
            this.dontContract = true;
        });
    }
}

document.addEventListener('alpine:init', () => {
    Alpine.data('container', (animateIn) => new Container(animateIn));
});